
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-a7a82f20\",\"scoped\":true,\"hasInlineConfig\":false}!@../../../static/css/dialogEntry.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./crmProductDetailsDialog.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a7a82f20\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./crmProductDetailsDialog.vue"),
  /* scopeId */
  "data-v-a7a82f20",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/crmDialog/crmProductDetailsDialog.vue
// module id = 1737
// module chunks = 0